import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import Header from './header';
import { withLocalize } from "react-localize-redux";
import Prism from 'prismjs';
import { withRouter } from 'react-router';
import { Link } from "react-router-dom";

function RouterLink(props) {
  return (
   <Link to={props.href}>{props.children}</Link>
  );
}

class Terms extends Component {

  constructor(props) {
    super(props)
    this.state = { terms: null };
    console.log(`Terms ctor`);
    this.update();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.terms !== nextState.terms) {
      return true;
    }
    if (this.props.activeLanguage && (this.props.activeLanguage.code !== nextProps.activeLanguage.code)) {
      console.log(`${this.props.activeLanguage.code} : ${nextProps.activeLanguage.code}`)
      return true;
    }
    return false;
  }

  componentDidUpdate() {
    Prism.highlightAll();
    this.update();
  }

  update(path) {
    var finalPath = this.props.path;
    if (path)
      finalPath = path;

    var lang = 'en';
    if (this.props.activeLanguage)
      lang = this.props.activeLanguage.code;

    var root = `${process.env.PUBLIC_URL}/markdown/`;

    fetch(`${root}${finalPath}.${lang}.md?v=1.045`).then((response) => response.text()).then((text) => {
      this.setState({ terms: text, afterSearch: false })
    })
  }

  showResults(s) {
    this.props.history.push({
      pathname: '/Search',
      state: { searchResults: s }
    })
  }

  render() {
    return (
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Header showResults={this.showResults.bind(this)} />
          <div className="container-fluid">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <div className="col markdown-body">
                <ReactMarkdown escapeHtml={false} source={this.state.terms} renderers={{ link: RouterLink }} />
              </div>
            </div>
          </div>
        </div>
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright © PeriaIT 2019</span>
            </div>
          </div>
        </footer>

      </div>

    );
  }
}

export default withRouter(withLocalize(Terms))